import { Box, Card, Typography } from "@mui/material";
import React from "react";
import { CHART_TEXT } from "./chartTheme";

type ChartCardProps = {
  title: React.ReactNode;
  // Optional headline figure shown under the title (e.g. a total).
  headline?: React.ReactNode;
  headlineCaption?: React.ReactNode;
  // Render only the chart, without this card, so another frame can wrap it (the Home page does).
  bare?: boolean;
  children: React.ReactNode;
};

// The shell every dashboard chart sits in, so cards share border, radius, padding and title style.
export const ChartCard = ({ title, headline, headlineCaption, bare, children }: ChartCardProps) =>
  bare ? (
    <>{children}</>
  ) : (
  <Card
    elevation={0}
    sx={{
      height: "100%",
      border: "1px solid #e5e7eb",
      borderRadius: 3,
      boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
      p: { xs: 2, md: 2.5 },
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography sx={{ fontSize: { xs: 14, md: 15 }, fontWeight: 600, color: CHART_TEXT.primary, flexGrow: 1 }}>{title}</Typography>
    </Box>
    {headline != null && (
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mt: 1 }}>
        <Typography sx={{ fontSize: 28, fontWeight: 800, lineHeight: 1, color: CHART_TEXT.primary }}>{headline}</Typography>
        {headlineCaption && <Typography sx={{ fontSize: 13, color: CHART_TEXT.muted }}>{headlineCaption}</Typography>}
      </Box>
    )}
    <Box sx={{ mt: 1.5, flexGrow: 1, minWidth: 0 }}>{children}</Box>
  </Card>
);
